<template>
<v-flex xs10 sm10 md4 offset-xs1>
  <v-card>
    <v-card-text>
      <div class="text-xs-center">
        <Camera size="80" :updateIcon="true" :url="image"></Camera>
      </div>

      <v-text-field
        v-model="name"
        ref="name"
        :error=!!errors.name
        :error-messages=errors.name
        name="name"
        ></v-text-field>

      <v-text-field
        v-model="email"
        ref="email"
        :error=!!errors.email
        :error-messages=errors.email
        name="email"
        ></v-text-field>

      <v-textarea
        v-model="description"
        ref="description"
        :hint="'max 100, actual: ' + `${description.length}`"
        :label="`${$t('register.description')}`"
        placeholder=""
        :error=!!errors.description
        :error-messages=errors.description
        name="description"
        ></v-textarea>

    </v-card-text>
      <v-card-actions>
      <v-btn
        class="ma-3"
        color="primary"
        :disabled="description.length > 100"
        :loading="isLoading"
        @click="save"
        >
        {{ $t('buttons.save') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="ma-3"
        color="error"
        flat
        :loading="isLoadingDeleting"
        @click="deleteDialog = true"
        dark>
        {{ $t('buttons.delete') }}
      </v-btn>
    </v-card-actions>
  </v-card>
    <v-dialog
    v-model="deleteDialog"
    max-width="290"
    >
    <v-card>
      <v-card-title class="headline">{{ $t('message.delete_account_dialog_title') }}</v-card-title>
      <v-card-text>
        {{ $t('message.delete_account_dialog_description') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          flat="flat"
          @click="deleteDialog = false"
          >
          {{ $t('message.delete_dialog_no') }}
        </v-btn>
        <v-btn
          color="darken-1"
          flat="flat"
          @click="deleteAccount"
          >
          {{ $t('message.delete_dialog_yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-flex>
</template>

<script>
const Camera = () => import('@/components/camera/Camera')

export default {

  data () {
    return {
      name: null,
      isLoading: false,
      isLoadingDeleting: false,
      email: null,
      description: '',
      errors: [],
      deleteDialog: false,
      media: null,
      image: null,
      menu: ''
    }
  },

  created () {
    this.$ga.page(this.$router)
  },

  mounted: function () {
    this.name = this.$auth.user().name
    this.email = this.$auth.user().email
    this.description = this.$auth.user().description
    this.media = this.$auth.user().media
    this.showImage()
  },

  components: {
    Camera
  },

  watch: {
    description: function (val) {
      if (val.length > 100) {
        this.errors.description = 'Max size exceeded'
      } else {
        delete this.errors['description']
      }
    }
  },

  computed: {
    base64Data: function () {
      return this.$store.getters['Device/getBase64']
    }
  },

  methods: {
    deleteAccount: function () {
      var self = this
      this.isLoadingDeleting = true
      this.$api.user.destroy({}).then((response) => {
        self.$ga.event({
          eventCategory: 'User Engagement',
          eventAction: 'Delete account',
          eventLabel: 'Successfully deleted account',
          eventValue: 0
        })
        self.isLoadingDeleting = false
        self.deleteDialog = false
        self.$auth.logout({ redirect: '/login' })
      }, response => {
        self.errors = (response.data && response.data.error) || []
        self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
        self.isLoadingDeleting = false
      })
    },
    save: function () {
      var self = this
      this.isLoading = true
      this.$api.user.update({ 'name': this.name, 'email': this.email, 'description': this.description }).then((response) => {
        self.$ga.event({
          eventCategory: 'User Engagement',
          eventAction: 'My Account',
          eventLabel: 'Successfully updated account',
          eventValue: 0
        })
        if (self.base64Data) {
          var base64 = self.base64Data.split(',')[1]
          self.$api.user.saveFile({ 'raw': base64 }).then((response) => {
            self.$store.dispatch('Device/saveBase64', false)
            self.media = response.data.media
            self.showImage()
          }, response => {
            self.errors = (response.data && response.data.error) || []
            self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
            self.isLoading = false
          })
        }
        self.$store.dispatch('Alert/newAlert', { type: 'success', message: this.$t('account.updated') })
        self.isLoading = false
      }, response => {
        self.errors = (response.data && response.data.error) || []
        self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
        self.isLoading = false
      })
    },
    showImage: function () {
      if (this.media && this.media.length > 0) {
        this.$api.user.getFile({ 'id': this.$auth.user().id }, { 'preset': '80x80' }).then((response) => {
          this.image = response.data.url
        })
      }
    }
  }
}
</script>
